'use strict';

var util = angular.module('gymsystem.util');

util.directive('iframewidget', ['$sce', '$rootScope', 'util', '$injector', function($sce, $rootScope, util, $injector) {
    return {
        restrict: 'E',
        template: '<div ng-if="loading" us-spinner></div><iframe ng-src="{{trustedSrc(getUrl())}}" width=100% style="border: 0" ng-style="style" allow="camera;microphone"></iframe>',
        scope: {
            settings: '=',
            control: '=?',
            onEvent: '=?',
            fillParent: '@'
        },
        link: function($scope, element) {
            $scope.loading = true;

            element[0].getElementsByTagName('iframe')[0].addEventListener('load', function() {
                $scope.$apply(function() {
                    $scope.loading = false;
                });
            });

            $scope.getUrl = function() {
                var s = angular.copy($scope.settings);
                delete s.url;

                if (s.pass_zoezi_user_id) {
                    s.zoezi_user_id = $rootScope.currentStaff.id;
                    s.zoezi_session_hash = $rootScope.currentSessionHash;
                    s.zoezi_host = $rootScope.getHost();
                }
                delete s.pass_zoezi_user_id;

                var url = $scope.settings.url;
                if (_.keys(s).length) {
                    if (url.indexOf('?') == -1) {
                        url += '?';
                    } else {
                        url += '&';
                    }
                    url += 'zoezi_settings=' + encodeURIComponent(JSON.stringify(s));
                }

                return url;
            };

            $scope.getIframeWindow = function() {
                return element[0].getElementsByTagName('iframe')[0].contentWindow;
            };

            $scope.$watch('settings', function() {
                var height = element.parent().parent().height();
                $scope.style = {height: (height-6) + 'px'};
                if ($scope.fillParent) {
                    $scope.style = {height: '100%', display: 'block'};
                } else if (util.isSmallScreen()) {
                    $scope.style = {height: 'calc(100vh - 138px)'};
                }
                $scope.trustedSrc = function(url) {
                     return $sce.trustAsResourceUrl(url);
                 };
             });

            if ($scope.control) {
                $scope.control.sizeChanged = function(width, height) {
                    $scope.style = {height: (height-62) + 'px', width: width + 'px'};
                };
            }

            var handleWidgetCall = function(data) {
                try {
                    var module_name = data.module || '$rootScope';
                    var module = $injector.get(module_name);
                    var args = data.args;
                    var fn = data.fn;
                    var callbackId = data.callbackId;

                    var isPromise = function(p) {
                        if (p && typeof p === 'object' && typeof p.then === 'function') {
                            return true;
                        }

                        return false;
                    };

                    const sanitizeForPostMessage = function(input, seen = new WeakMap()) {
                        // Primitives and null/undefined
                        if (input === null || input === undefined) return input;
                        const t = typeof input;
                        if (t === "function" || t === "symbol") return undefined;
                        if (t !== "object") return input;

                        // Cycles
                        if (seen.has(input)) return seen.get(input);

                        // Treat DOM nodes/windows as non-cloneable but preserve structure (set to undefined)
                        if ((typeof Node !== "undefined" && input instanceof Node) ||
                            (typeof Window !== "undefined" && input instanceof Window)) {
                            return undefined;
                        }

                        // Pass-through: known structured-cloneables/transferables
                        if (
                            input instanceof Date ||
                            input instanceof RegExp ||
                            input instanceof Blob ||
                            input instanceof File ||
                            (typeof FileList !== "undefined" && input instanceof FileList) ||
                            input instanceof ArrayBuffer ||
                            ArrayBuffer.isView(input)            // TypedArray/DataView
                        ) {
                            return input; // let postMessage/structuredClone handle it
                        }

                        // Arrays: preserve length, indices, and holes
                        if (Array.isArray(input)) {
                            const out = new Array(input.length);
                            seen.set(input, out);
                            // We intentionally preserve sparse array holes for fidelity with the original array structure.
                            // This is important for cases where the array's shape (including holes) must be retained.
                            for (let i = 0; i < input.length; i++) {
                                if (!Object.prototype.hasOwnProperty.call(input, i)) continue; // keep hole
                                const v = input[i];
                                if (typeof v === "function" || typeof v === "symbol") {
                                    out[i] = undefined; // preserve position
                                } else {
                                    out[i] = sanitizeForPostMessage(v, seen); // may be undefined, and that's ok
                                }
                            }
                            return out;
                        }

                        // Plain objects: always keep the key unless original is function/symbol
                        const out = {};
                        seen.set(input, out);
                        for (const k in input) {
                            if (!Object.prototype.hasOwnProperty.call(input, k)) continue;
                            const v = input[k];
                            if (typeof v === "function" || typeof v === "symbol") {
                                out[k] = undefined;
                            } else {
                                out[k] = sanitizeForPostMessage(v, seen); // may be undefined, key is preserved
                            }
                        }
                        return out;
                    };

                    var postResult = function(callbackId, data) {
                        const sanitizedData = sanitizeForPostMessage(data);
                        $scope.getIframeWindow().postMessage({callbackId: callbackId, data: sanitizedData});
                    };

                    // A special case for handling live.subscribe({callbackId: ...})
                    if (module_name == 'live' && fn == 'subscribe' && args && args.length == 1) {
                        var liveCallbackId = args[0].callbackId;
                        var callback = function(data) {
                            postResult(liveCallbackId, data);
                        };
                        args[0].callback = callback;
                        args[0].callbackId = null;
                        args[0].scope = $scope;
                    }

                    var callResult = module[fn].apply(null, args);
                    if (callbackId) {
                        if (isPromise(callResult)) {
                            callResult.then(function(data) {
                                postResult(callbackId, data);
                            });
                        } else {
                            postResult(callbackId, callResult);
                        }
                    }
                }
                catch(e) {
                    console.log('Error calling {0}: '.format(data) + e);
                }
            };

            var handleIframeMessage = function(event) {
                if (event.source && event.source.window == $scope.getIframeWindow()) {
                    $scope.$apply(function() {
                        handleWidgetCall(event.data);

                        if ($scope.onEvent) {
                            $scope.onEvent(event);
                        }
                    });
                }
            };
            window.addEventListener('message', handleIframeMessage);
            $scope.$on('$destroy', function () {
                window.removeEventListener('message', handleIframeMessage);
            });
        }
    };
}]);
